export type FilterSchema =  Checkbox;

export enum FilterType {
    checkbox = 'checkbox'
}

interface BaseFilter {
    label: string
    name: string
    type: FilterType
}

interface Checkbox extends BaseFilter {
    type: FilterType.checkbox
    values: {name: string, id: number, count?: number}[]
}
